(function () {
  'use strict';

  var SERVICE_SKU = 'FT24SHELTER';
  var SERVICE_PROPERTY = '_ez_fast_track_service';
  var syncing = null;
  var rerunRequested = false;

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[®™]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function itemText(item) {
    var properties = Object.entries(item.properties || {})
      .map(function (entry) { return entry[0] + ' ' + entry[1]; })
      .join(' ');

    return normalize([
      item.product_title,
      item.title,
      item.variant_title,
      item.sku,
      item.product_type,
      properties
    ].join(' '));
  }

  function isCompatibleShelterTop(item) {
    var value = itemText(item);
    if (/\bframe\b|\bcadre\b/.test(value)) return false;

    return (
      /\btop\b|\btoit\b/.test(value) &&
      /fusion|digital|printed|imprim/.test(value)
    );
  }

  function nextProperties(item, serviceSku) {
    var properties = Object.assign({}, item.properties || {});

    if (serviceSku) properties[SERVICE_PROPERTY] = serviceSku;
    else delete properties[SERVICE_PROPERTY];

    return properties;
  }

  function hasDesiredProperty(item, serviceSku) {
    return String((item.properties || {})[SERVICE_PROPERTY] || '').toUpperCase() === serviceSku;
  }

  async function updateLine(item, serviceSku) {
    var response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: item.key,
        quantity: item.quantity,
        properties: nextProperties(item, serviceSku)
      })
    });

    if (!response.ok) throw new Error('Unable to link Fast Track production to its shelter top.');
    return response.json();
  }

  async function synchronizeFastTrack() {
    if (syncing) {
      rerunRequested = true;
      return syncing;
    }

    syncing = (async function () {
      var response = await fetch(window.Shopify.routes.root + 'cart.js', {
        headers: { 'Accept': 'application/json' }
      });
      if (!response.ok) return;

      var cart = await response.json();
      var serviceCount = cart.items
        .filter(function (item) { return String(item.sku || '').toUpperCase() === SERVICE_SKU; })
        .reduce(function (sum, item) { return sum + Number(item.quantity || 0); }, 0);
      var candidates = cart.items.filter(isCompatibleShelterTop);
      var eligibleCount = Math.min(serviceCount, candidates.length);

      for (var index = 0; index < candidates.length; index += 1) {
        var desiredService = index < eligibleCount ? SERVICE_SKU : '';
        if (hasDesiredProperty(candidates[index], desiredService)) continue;
        await updateLine(candidates[index], desiredService);
      }
    })().catch(function (error) {
      console.error('[E-Z UP Fast Track]', error);
    }).finally(function () {
      syncing = null;
      if (rerunRequested) {
        rerunRequested = false;
        window.setTimeout(synchronizeFastTrack, 50);
      }
    });

    return syncing;
  }

  function scheduleSync() {
    window.setTimeout(synchronizeFastTrack, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  } else {
    scheduleSync();
  }

  document.addEventListener('cart:refresh', scheduleSync);
  document.addEventListener('cart:rerendered', scheduleSync);
  document.addEventListener('cart:updated', scheduleSync);
  document.addEventListener('cart:update', scheduleSync);
}());
